import _nanoid from 'nanoid';

export function nanoid(prefix) {
  return `${prefix || 'pr'}-${_nanoid()}`;
}



// WEBPACK FOOTER //
// ./src/lib/nanoid.js